import React from "react";
import {
  IconButton as ChakraIconButton,
  Icon,
  type IconButtonProps as ChakraIconButtonProps,
  type IconProps,
} from "@chakra-ui/react";

type BaseIconButtonProps = {
  /**
   * Button's meaning for screen readers.
   */
  "aria-label": string;

  /**
   * Button variant, which determines the purpose the button is used for and its appearance.
   *
   * @default "secondary"
   */
  variant?: "primary" | "secondary";

  /**
   * Determines the height of the button.
   *
   * @default "md"
   */
  size?: "sm" | "md" | "lg";

  /**
   * Button icon.
   */
  icon: (props: IconProps) => JSX.Element;
};

export type IconButtonProps = BaseIconButtonProps &
  Omit<ChakraIconButtonProps, "aria-label" | "variant" | "size" | "icon">;

export function IconButton({ variant = "secondary", size = "md", children, icon, ...props }: IconButtonProps) {
  return (
    <ChakraIconButton variant={variant} size={size} icon={<Icon as={icon} boxSize={`icon.${size}`} />} {...props} />
  );
}
